/*
  Used primarily to overwrite poorly worded network messages in an effort to improve UX

  The `modifiedMessages` object contains the constant and the message string to change,
  along with the replacement message as the value
*/

const modifiedMessages = {};

export default ({ errorConstant, message }) => {
  const combinedKey = `${errorConstant}:${message.trim()}`.trim();
  const result = modifiedMessages[combinedKey];
  return result || message;
};
